var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delete",
    clipPath: "url(#clip0_579_877)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.5268 2.7575L9.28487 6.99985L13.5268 11.242C14.1578 11.8732 14.1578 12.8957 13.5268 13.5269C13.2115 13.8421 12.7982 13.9999 12.3851 13.9999C11.9713 13.9999 11.5579 13.8424 11.2429 13.5269L7.00003 9.28424L2.7575 13.5268C2.44228 13.8421 2.02891 13.9999 1.61542 13.9999C1.20206 13.9999 0.788968 13.8423 0.473465 13.5268C-0.1575 12.8959 -0.1575 11.8734 0.473465 11.242L4.71527 6.99981L0.473224 2.7575C-0.157741 2.12653 -0.157741 1.10382 0.473224 0.472861C1.10407 -0.15762 2.12618 -0.15762 2.75726 0.472861L6.99999 4.71521L11.2424 0.472861C11.8736 -0.15762 12.8958 -0.15762 13.5266 0.472861C14.1578 1.10382 14.1578 2.12653 13.5268 2.7575Z",
    fill: "#29185E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_579_877"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.96fa2d3e0f9d206c8ce63dc8ec0ed7cd.svg";
export { ForwardRef as ReactComponent };